import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES } from 'radiance-ui/lib/constants';

type MediaQueriesType = keyof typeof MEDIA_QUERIES;

export const mobileOnly = (
  displayType = 'block',
  breakpoint: MediaQueriesType = 'mdUp',
) => css`
  display: ${displayType};

  ${MEDIA_QUERIES[breakpoint]} {
    display: none;
  }
`;

export const tabletOnly = (
  displayType = 'block',
  breakpoint1: MediaQueriesType = 'mdUp',
  breakpoint2: MediaQueriesType = 'lgUp',
) => css`
  display: none;

  ${MEDIA_QUERIES[breakpoint1]} {
    display: ${displayType};
  }

  ${MEDIA_QUERIES[breakpoint2]} {
    display: none;
  }
`;

export const desktopOnly = (
  displayType = 'block',
  breakpoint: MediaQueriesType = 'mdUp',
) => css`
  display: none;

  ${MEDIA_QUERIES[breakpoint]} {
    display: ${displayType};
  }
`;

export const ResponsiveText = styled.span<{ desktop?: boolean }>`
  ${({ desktop }) => (desktop ? desktopOnly('inline') : mobileOnly('inline'))}
`;
